import * as React from 'react';
import * as styles from './RatingLegend.css';

interface ILegend {
  legend: string;
  color: string;
}

interface IRatingLegendProps {
  legends: ILegend[];
}

export function RatingLegend({ legends }: IRatingLegendProps) {
  return (
    <ul className={styles['list']}>
      {legends.map((item, index) => (
        <li key={index} className={styles['list__item']}>
          <mark style={{ backgroundColor: item.color }} className={styles['list__item-mark']} />

          <span>{item.legend}</span>
        </li>
      ))}
    </ul>
  );
}
